import axios from 'axios';
import qs from 'query-string';
import { handleResult } from './api';

/**
 * 쿠폰 API 호출
 * @param {*} store 
 * @param {*} userId 
 * @param {*} couponNum 
 * @returns 
 */
const use = async (store, userId, couponNum) => {
    const params = {
        storeID: store,
        userID: userId,
        couponNumber: couponNum
    }

    const result = await axios.post(process.env.GATSBY_COUPON_API_URL, qs.stringify(params));
    const data = handleResult(result);
    if (data.status !== 1)
        throw new Error(convertMessage(data));

    return data;
};

const convertMessage = data => {
    switch (data.errorcode) {
        case 400:
            return '잘못된 UID입니다.\n계정 UID를 다시 한 번 확인해주세요.';
        case 404:
            return '보상을 지급할 수 없습니다.\n해당 계정으로 이미 지급된 쿠폰입니다.';
        default:
            return data.message;
    }
}
export default {
    use
}